import { Address } from '../../utils/types'

export interface Token {
  symbol: string
  name: string
  address: Address
  decimals: number
}

export function isTokenNative(token: Token) {
  return (
    token.symbol === 'MATIC' &&
    token.address.toLowerCase() === '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'
  )
}
